import { BASE_THEME } from './base.mjs';
import { paragraph, textBase } from './styles/viewModeOnly.mjs';

const EDIT_MODE_THEME = {
  ...BASE_THEME
};
const VIEW_MODE_THEME = {
  ...BASE_THEME,
  text: {
    ...BASE_THEME.text,
    base: textBase.className
  },
  paragraph: paragraph.className
};

export { EDIT_MODE_THEME, VIEW_MODE_THEME };
//# sourceMappingURL=index.mjs.map
